import React from 'react';
import styled, { keyframes } from 'styled-components';

const Loading = keyframes`
    0% {
      opacity: 1;
    }
    25% {
      opacity: 0.5;
    }
    50% {
      opacity: 0.1;
    }
    75% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
`;
const Container = styled.div`
  margin-top: -125px;
  height: 100vh;
  width: 100vw;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Ball = styled.div`
  margin: 15px;
  height: 12px;
  width: 12px;
  border-radius: 50%;
  background-color: white;
  opacity: 0.5;
  @media (max-width: 768px) {
    height: 7px;
    width: 7px;
  }
`;

const BallContainer = styled.div`
  display: flex;
  animation-name: Loading;
  animation-iteration-count: infinite;
  ${Ball}:nth-child(1) {
    animation: ${Loading} 1s 0s infinite linear alternate;
  }
  ${Ball}:nth-child(2) {
    animation: ${Loading} 1s 0.1s infinite linear alternate;
  }
  ${Ball}:nth-child(3) {
    animation: ${Loading} 1s 0.2s infinite linear alternate;
  }
`;

export const Loader = () => {
  return (
    <Container>
      <BallContainer>
        <Ball />
        <Ball />
        <Ball />
      </BallContainer>
    </Container>
  );
};
